import ImputComponent from "../InputComponent";
import SearchIcon from "@material-ui/icons/Search";
import { useLanguage } from "../../store/languageContext";
import { LanguageFactory } from "@factories/Utilities/languageFactory";
import "./FilterDropdown.styles.scss";
import ActionBar from "./ActionBar";
import { Form, Input, Select } from "antd";
import { ChangeEvent, useState } from "react";
import InputComponent from "../InputComponent";

interface propType { 
  propertyid?: string,
  selectedChain?:string,
    updateFilterParams:(supplier?:string, hotelCode?:string) => void,
  userChains: string[],
  closeFilterForm: () => void
  getFilterData: (supplier?:string, hotelCode?:string) => void,

  //setPropertyId: (value: string) => void,
}



const FilterDropdown = (props: propType) => {
  const { language, setLanguage } = useLanguage();
  const lang = new LanguageFactory(language);
  const Option = Select.Option;
  const [supplier, setSupplier] = useState<string | any>();
  const [hotelCode, setHotelCode] = useState<string | any>();


    const onClose = () => {
    props.closeFilterForm()

    //setTogglePopup
  };
  const onSave = () => {
     props.updateFilterParams(supplier, hotelCode)
      //set filtered datat for props and save
    props.getFilterData(supplier, hotelCode)
    //applyChangesve
    //setPropertyId
    //setTogglepopoup
    //setselectedChain
  };
  const handleChange = (e: string) => {
      setHotelCode(e)
  };

  const changeChainSelection = (e: string) => {
      setSupplier(e)
  };

  const sortFunction = (a: string,  b: string)=>{
      if (a.toLowerCase() < b.toLowerCase()) {
        return -1;
      }
      if (a.toLowerCase() > b.toLowerCase()) {
        return 1;
      }
      return 0;

  }

  return (
    <Form
      className="filter-dropdown-container"
      labelAlign = "left"
     // form={form}
      layout="vertical"
      onFinish={onSave}>
      <Form.Item
        label="Chain"
        name="chaintype"
        className="input-container"
        rules={[
          {
            required: true,
            message: "This field is required",
          },
        ]}
      >
        <Select allowClear className="FilterSelection"
          //defaultValue={props.selectedChain}
          placeholder="Please select a chain"
          showSearch
          onChange={(e: string) => changeChainSelection(e)}
        >
          {props.userChains.sort(sortFunction).map((item: string, i: number) => (
            <Option key={`${item}-${i}`} value={item}>
              {item}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
       className="input-container"
       label="Propertid"

       >

        <InputComponent
          className="FilterInput"
          onChange={handleChange}
          placeholder="Search Propertyid"
          value={hotelCode}
          endAdornment={<SearchIcon style={{ color: "#9a9a9a" }} />}
        />
      </Form.Item>
      <ActionBar
        onCancel={onClose}
        onSave={onSave}
        disabledSave={false}
        show={true}
      />
    </Form>
  );
};

export default FilterDropdown;
